module.exports = __webpack_public_path__ + "static/media/IMG_7304_DxO.19a42d61.jpg";